<template>
<el-dialog :title="this.viewFlag == 'view' ? '查看' : '修改'" :close-on-click-modal="false" width="90%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" size="small" class="org-dialog-form">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="3" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="发票代码:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="invoiceCode" style="margin-bottom: 0;">
                        <span v-if="this.viewFlag == 'view'">{{dataForm.invoiceCode}}</span>
                        <el-input v-else v-model="dataForm.invoiceCode" placeholder="发票代码"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="发票号:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="invoiceNo" style="margin-bottom: 0;">
                        <span v-if="this.viewFlag == 'view'">{{dataForm.invoiceNo}}</span>
                        <el-input v-else v-model="dataForm.invoiceNo" placeholder="发票号"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="开票日期:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="billingDate" style="margin-bottom: 0">
                        <span v-if="this.viewFlag == 'view'">{{dateFormat(dataForm.billingDate)}}</span>
                        <el-date-picker v-else v-model="dataForm.billingDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="联系人:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="contacts" style="margin-bottom: 0;">
                        <span v-if="this.viewFlag == 'view'">{{dataForm.contacts}}</span>
                        <el-input v-else v-model="dataForm.contacts" placeholder="联系人"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="联系方式:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="contactInfo" style="margin-bottom: 0;">
                        <span v-if="this.viewFlag == 'view'">{{dataForm.contactInfo}}</span>
                        <el-input v-else v-model="dataForm.contactInfo" placeholder="联系方式"></el-input>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
            <div class="attachment-section">
                <FilesUpDown ref="filesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
            </div>
        </div>
    </el-form>
    <el-row :gutter="40">
        <el-col :span="24" style="text-align:right;">
            <el-button v-if="this.viewFlag == 'edit'" size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <el-button v-if="this.viewFlag == 'edit'" size="small" type="primary" @click="dataFormSubmit()">
                确定
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    edit,queryById
} from '@/controller/settlement'
import moment from 'moment'
import FilesUpDown from "@/views/common/file-up-down";
export default {
    data() {
        return {
            FILE_BIZ_TYPE: 21,
            viewData: {
                visible: false,
                width: ''
            },
            viewFlag: '',
            dataForm: {
                id: 0,
                invoiceCode: '',//发票代码
                invoiceNo: '',//发票号
                billingDate: '',//开票日期
                contacts: '',//联系人
                contactInfo: ''//联系方式
            },
            dataRule: {
                invoiceCode: [
                    { required: true, message: '发票代码不能为空', trigger: 'blur' }
                ],
                invoiceNo: [
                    { required: true, message: '发票号不能为空', trigger: 'blur' }
                ],
                billingDate: [
                    { required: true, message: '开票日期不能为空', trigger: 'blur' }
                ],
                contacts: [
                    { required: true, message: '联系人不能为空', trigger: 'blur' }
                ],
                contactInfo: [
                    { required: true, message: '联系方式不能为空', trigger: 'blur' }
                ]
            }
        }
    },
    components: {
        FilesUpDown
    },
    mounted() {},
    methods: {
        init(data, id, viewFlag) {
            this.dataForm.id = id || 0
            this.viewData.visible = true
            this.viewFlag = viewFlag;
            this.$nextTick(() => {
                if (this.dataForm && this.dataForm.id) {
                    this.$refs.filesUpDown.init(this.viewFlag);
                  console.log('查询id是什么',this.dataForm.id)
                  queryById({}, this.dataForm.id).then(data => {
                        if (data && data.code === '00') {
                          console.log('查询到的数据')
                            this.dataForm = data.body
                        }
                    });
                }
            })

        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                const params = {
                'id': this.dataForm.id,
                'invoiceCode': this.dataForm.invoiceCode,//发票代码
                'invoiceNo': this.dataForm.invoiceNo,//发票号
                'billingDate': this.dataForm.billingDate,//开票日期
                'contacts':this.dataForm.contacts,//联系人
                'contactInfo':this.dataForm.contactInfo,//联系方式
                }
                console.log(params);
                if (valid) {
                    if (this.dataForm.id) {
                        edit(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        dateFormat(date) {
            if(!date){
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 392px;'
        }
    }
}
</script>
